import {
	Component,
	EventEmitter,
	Inject,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import { TreeNode } from 'primeng/api';
import { OrgNodeConfig } from './models/org-node.model';
import { Utils } from 'formiojs';
import { AddEditOrgItem } from './add-edit-org-item/add-edit-org-item.component';
import { MatDialog } from '@angular/material/dialog';
import _cloneDeep from "lodash/cloneDeep";
import { MatMenuTrigger } from '@angular/material/menu';
import * as DeleteConfirmationDialog from 'dp-formio';
import { RejectReasonOrgItem } from './reject-reason-org-item/reject-reason-org-item.component';
import { FormioCustomComponent, FormioComponent, FormioLoader, FormioAppConfig } from 'dp-formio';
import { APP_BASE_HREF } from '@angular/common';
import { ViewFormDialog } from './view-form/view-form.component';

declare var WZoom: any;

@Component({
	selector: 'app-org-wrapper',
	templateUrl: './org-wrapper.component.html',
	// styleUrls: ['./org-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class OrgWrapperComponent
	implements FormioCustomComponent<any>, OnChanges, OnDestroy {
	@ViewChild(MatMenuTrigger) matMenuTrigger: MatMenuTrigger;
	@ViewChild(FormioComponent) formComponent: FormioComponent;

	dir: 'rtl' | 'ltr';
	@Input() required: boolean;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Input() disabled: boolean;
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;

	orgNodeConfig: OrgNodeConfig;
	orgData: TreeNode[] = [];
	dataItems: any;

	currentLang = '';
	menuTopLeftPosition = { x: '0', y: '0' }

	showTakeDecisionMsg = false;
	hasRejectedDecision = false;
	decisionState = {
		approve: 'approve',
		reject: 'reject'
	}
	hasDecision = false;

	decisionKey: string;
	rejectReasonKey: string;
	cssDecisionKey: string;

	subscriptions$: Subscription[] = [];
	set sub(s: Subscription) {
		this.subscriptions$.push(s);
	}

	constructor(private translateService: TranslateService,
		private dialog: MatDialog,
		public formioLoader: FormioLoader,
		private formioAppConfig: FormioAppConfig,
		@Inject(APP_BASE_HREF) private baseHref: string) {
		this.currentLang = this.translateService.currentLang;
		this.changeDirection(this.translateService.currentLang);
		this.translateService.onLangChange.subscribe(event => {
			this.currentLang = event.lang;
			this.changeDirection(event.lang);
		});
	}
	ngOnInit() {
		this.init();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (this.customOptions && this.customOptions.node) {
			this.decisionKey = this.customOptions.takeDecision?.decisionKeys[0];
			this.rejectReasonKey = this.customOptions.takeDecision?.rejectReasonKeys[0];
			this.cssDecisionKey = this.customOptions.takeDecision?.cssDecisionKeys[0];

			this.orgNodeConfig = _cloneDeep(this.customOptions.node);
			this.initItems(this.orgNodeConfig);

			if (this.value) {
				if (this.customOptions.takeDecision?.hasDecision)
					this.hasDecision = Utils.evaluate(this.customOptions.takeDecision.hasDecision, { data: this.data })
				this.dataItems = _cloneDeep(this.value);
				this.initValue();
				this.notifyValue();
			} else {
				this.afterChangeValue();
			}
		}
	}

	ngOnDestroy() {
		this.subscriptions$.forEach((o) => o.unsubscribe());
		this.subscriptions$ = [];
	}

	openProfile(currentNode: any) {
		const model = Utils.evaluate(this.customOptions.profileResourceData, {
			config: this.formioAppConfig,
			...(currentNode?.data?.dataItem || {})
		});
		this.dialog.open(ViewFormDialog, {
			data: {
				formKey: model.formKey,
				endpoint: model.endpoint,
				dir: this.data.dir,
			},
			width: '70%',
		});
	}

	notifyValue() {
		if (this.orgData?.length) {
			const data = this.cleanData(_cloneDeep(this.orgData[0]));
			this.dataItems = data;
			this.formioComponent.customValidationValid = true;

			if (this.required) {
				let valid = this.orgNodeConfig.maxItem == this.orgData.length;
				if (valid) {
					valid = this.validateChildren(this.orgNodeConfig.children);
				}

				if (!valid) {
					this.formioComponent.customValidationValid = false;
				}
			}
			this.value = data;
			this.valueChange.emit(this.value);

			this.showTakeDecisionMsg = false;
			this.hasRejectedDecision = false;
			this.checkRejectedDecision(this.value);
			this.checkAllDecisions(this.value);

			this.afterChangeValue();
		}
	}

	validateChildren(children: any[] = []) {
		let valid = true;
		for (let index = 0; index < children.length; index++) {
			const node = children[index];
			const nodes = this.findByKey(node.key, this.orgData);
			const parentMaxItems = this.findParentMaxItem(node.key, this.orgNodeConfig);

			if ((node.relatedToParent && node.maxItem > nodes.length) ||
				(!node.relatedToParent && (node.maxItem * parentMaxItems) > nodes.length)) {
				valid = false;
				break;
			} else if (node.children?.length) {
				valid = this.validateChildren(node.children);
				if (!valid) break;
			}
		}
		return valid;
	}
	findByKey(key: string, nodes: any[], result: any[] = []) {
		nodes.forEach(node => {
			if (node.data.node.key == key) result.push(node);
			if (node.data.node.children) {
				this.findByKey(key, node.children, result);
			}
		});
		return result;
	}
	findParentMaxItem(key: string, item: OrgNodeConfig): number {
		if (item.key == key) return +item.maxItem;
		else if (item.children?.length) {
			const child = item.children.find(q => q.key == key);
			if (child) {
				return +item.maxItem;
			}
			else {
				let result = 0;
				for (let index = 0; index < item.children.length; index++) {
					result = this.findParentMaxItem(key, item.children[index]);
					if (result > 0) break;
				}
				return result;
			}
		}
		return 0;
	}

	onRightClick(event: MouseEvent, currentNode) {
		event.preventDefault();
		this.menuTopLeftPosition.x = event.clientX + 'px';
		this.menuTopLeftPosition.y = event.clientY + 'px';

		if (!this.viewOnly) {
			let actions = [];
			if (this.customOptions.takeDecision?.enabled) {
				actions = [
					{ key: this.decisionState.approve, label: this.translateService.instant('forms.common.Approve'), disable: false },
					{ key: this.decisionState.reject, label: this.translateService.instant('forms.common.Reject'), disable: false }
				];
			} else {
				actions.push({ key: 'edit', label: this.translateService.instant('forms.common.Edit'), disable: false });
				currentNode.data.node.children?.forEach(node => {
					if (node.relatedToParent) {
						const roleInSameParentCount = this.dataItems.children.filter(q => q.role == node.relatedToParent).map(q => q.children).flat().length;
						const disable = node.maxItem <= roleInSameParentCount;
						actions.push({ key: node.key, label: `${this.translateService.instant('forms.common.Add')} ${this.translateService.instant(`forms.common.${node.key}`)}`, disable });
					} else {
						const model = this.findDataModel(currentNode.data.dataItem.id);
						const disable = node.maxItem <= (model.children?.filter(q => q.role == node.key)?.length || 0);
						actions.push({ key: node.key, label: `${this.translateService.instant('forms.common.Add')} ${this.translateService.instant(`forms.common.${node.key}`)}`, disable });
					}
				});
				actions.push({ key: 'delete', label: this.translateService.instant('delete'), disable: false });
			}

			this.matMenuTrigger.menuData = {
				actions,
				currentNode
			}
			this.matMenuTrigger.openMenu();
		}
	}

	orgItemClicked(key: string, currentNode: any) {
		switch (key) {
			case 'edit':
				this.add(currentNode.data.node, null, currentNode.data.dataItem);
				break;
			case 'delete':
				this.deleteNode(currentNode);
				break;
			case this.decisionState.approve:
				currentNode.data.dataItem[this.cssDecisionKey] = key;
				currentNode.data.dataItem[this.decisionKey] = key;
				currentNode.data.dataItem[this.rejectReasonKey] = '';
				this.notifyValue();
				break;
			case this.decisionState.reject:
				this.showRejectReason(false, currentNode.data.dataItem[this.rejectReasonKey], this.rejectReasonKey, (reason) => {
					currentNode.data.dataItem[this.cssDecisionKey] = key;
					currentNode.data.dataItem[this.decisionKey] = key;
					currentNode.data.dataItem[this.rejectReasonKey] = reason;
					this.notifyValue();
				});
				break;
			default:
				const subNode = currentNode.data.node.children.find(q => q.key == key);
				this.add(subNode, currentNode.data.dataItem.id);
				break;
		}
	}
	showReason(data: any, rejectKey: string) {
		const key = this.customOptions?.takeDecision?.rejectReasonKeys?.find(k => !!data[k]);
		this.showRejectReason(true, data[key], rejectKey);
	}

	private showRejectReason(disabled: boolean, reason: string, rejectKey: string, callback: (reason) => void = null) {
		this.dialog.open(RejectReasonOrgItem, {
			data: {
				reason: reason || '',
				disabled: disabled,
				dir: this.dir,
				rejectKey: rejectKey
			},
			width: '70%',
			panelClass: 'custom-event-modal-component',
			disableClose: false,
		}).afterClosed()
			.pipe(filter(q => !!q))
			.subscribe(result => {
				if (callback) callback(result);
			});
	}

	add(node: OrgNodeConfig, parentId: string = null, editDataItem: any = null) {
		let data = {};
		if (node.form?.data)
			data = Utils.evaluate(node.form.data, {
				role: node.key,
				selectedIds: this.getSelectedIds([], this.dataItems, editDataItem ? editDataItem.id : null),
				data: this.data,
				id: editDataItem?.id
			});
		this.dialog.open(AddEditOrgItem, {
			data: {
				title: editDataItem ? 'Edit' : 'Add',
				isFormio: this.customOptions.isFormio,
				isMassar: this.customOptions.isMassar,
				viewOnly: false,
				formKey: node.form.key,
				submission: { data },
				dir: this.dir,
				customOptions: this.customOptions
			},
			height: '100vh',
			width: '100vw',
			panelClass: 'full-screen-modal',
			direction: this.dir,
			autoFocus: false,
			restoreFocus: false,
			disableClose: false,
		}).afterClosed()
			.pipe(filter(q => !!q))
			.subscribe(result => {

				const dataItem = Utils.evaluate(node.form.bindResult, { result, data: this.data });

				if (editDataItem) {
					const node = this.findNode(editDataItem.id);
					node.data.dataItem = {
						...node.data.dataItem,
						...dataItem
					}
					this.customOptions?.takeDecision?.cssDecisionKeys?.forEach(key => {
						node.data.dataItem[key] = '';
					});
					this.customOptions?.takeDecision?.decisionKeys?.forEach(key => {
						node.data.dataItem[key] = '';
					});
					this.customOptions?.takeDecision?.rejectReasonKeys?.forEach(key => {
						node.data.dataItem[key] = '';
					});
				} else {
					const item = {
						type: 'orgItem',
						expanded: true,
						data: {
							dataItem: {
								...dataItem,
								order: 0
							},
							node: node
						},
						children: []
					};
					if (parentId)
						this.addToParent(this.orgData[0], parentId, item);
					else this.orgData.push(item);
				}
				this.orgData = _cloneDeep(this.orgData);
				this.notifyValue();

				this.formioComponent?.root?.events?.emit('formio.registerComponent');
			});
	}
	cssDecisionClass(node) {
		const key = this.customOptions?.takeDecision?.cssDecisionKeys?.findLast(key => node.data.dataItem[key]);
		if (!key) return '';
		return node.data.dataItem[key];
	}
	hasRejectReason(node: any) {
		const index = this.customOptions?.takeDecision?.rejectReasonKeys?.findIndex(key => !!node.data.dataItem[key]);
		return index >= 0 ? this.customOptions?.takeDecision?.rejectReasonKeys[index] : null;
	}

	private afterChangeValue() {
		if (this.customOptions && this.customOptions.afterChange)
			this.customOptions.afterChange.forEach(item => {
				const mustUpdateValues = item.condition ? this.formioComponent.evaluate(item.condition, { data: this.data }) : true;
				if (mustUpdateValues) {
					if (this.formioComponent.root.wizard) {
						const pages = this.formioComponent.root.getFastPages({ all: true, withoutFirstLoad: true });
						this.searchAndUpdateComponent(pages, item);
					} else {
						const nestedForms = Utils.searchComponents(this.formioComponent.root.components, { type: 'form', 'component.display': 'wizard' });
						nestedForms.forEach(formComponent => {
							formComponent.subFormReady.then((subForm) => {
								const pages = subForm.getFastPages({ all: true, withoutFirstLoad: true });
								this.searchAndUpdateComponent(pages, item);
							});
						});

						const components = this.searchAndUpdateComponent(this.formioComponent.root.components, item);
						if (!components?.length) {
							const nestedForms = Utils.searchComponents(this.formioComponent.root.components, { type: 'form' });
							nestedForms.forEach(formComponent => {
								formComponent.subFormReady.then((subForm) => {
									this.searchAndUpdateComponent(subForm.components, item);
								});
							});
						}
					}
				}
			});
	}

	private searchAndUpdateComponent(formComponents: any[], afterChangeItem: any): any[] {
		const components = Utils.searchComponents(formComponents, { key: afterChangeItem.key });
		components.forEach(c => {
			const value = this.formioComponent.evaluate(afterChangeItem.value, {
				data: this.data,
				hasRejectedDecision: this.hasRejectedDecision,
				showTakeDecisionMsg: this.showTakeDecisionMsg
			});
			c.setValue(value);
		});
		return components;
	}

	private checkRejectedDecision(dataItem: any) {
		if (this.customOptions?.takeDecision?.decisionKeys?.some(key => dataItem[key] == this.decisionState.reject)) {
			this.hasRejectedDecision = true;
			return this.hasRejectedDecision;
		}

		for (let index = 0; index < dataItem.children.length; index++) {
			const result = this.checkRejectedDecision(dataItem.children[index]);
			if (result) {
				this.hasRejectedDecision = true;
				break;
			}
		}
		return this.hasRejectedDecision;
	}

	private checkAllDecisions(dataItem: any) {
		if (this.customOptions?.takeDecision?.decisionKeys?.some(key => !dataItem[key])) {
			this.showTakeDecisionMsg = true;
			return this.showTakeDecisionMsg;
		}

		for (let index = 0; index < dataItem.children.length; index++) {
			const result = this.checkAllDecisions(dataItem.children[index]);
			if (result) {
				this.showTakeDecisionMsg = true;
				break;
			}
		}
		return this.showTakeDecisionMsg;
	}

	private initValue() {
		if (this.value.role == this.orgNodeConfig.key) {
			const node = this.recursiveInitValue(this.value, this.orgNodeConfig);
			this.orgData = [node];
			this.orgData = _cloneDeep(this.orgData);
		}
	}

	private recursiveInitValue(dataItem, nodeItem) {
		const data = _cloneDeep(dataItem);

		const childrenNodes = [];
		dataItem.children.forEach(child => {
			const childs = this.recursiveInitValue(child, nodeItem.children.find(q => q.key == child.role));
			childrenNodes.push(childs);
		});

		const node = {
			type: 'orgItem',
			expanded: true,
			data: {
				dataItem: data,
				node: nodeItem
			},
			children: childrenNodes
		};
		return node;
	}

	private deleteNode(currentNode: any) {
		DeleteConfirmationDialog.build(
			this.formioComponent,
			() => {
				this.recursiveDeleteNode(currentNode.data.dataItem.id);
				this.orgData = _cloneDeep(this.orgData);
				this.notifyValue();
				console.log(currentNode.data.dataItem.id);
			},
			null,
			'Are you sure to delete this item'
		);
	}

	private recursiveDeleteNode(id: string, nodes: any = this.orgData) {
		const index = nodes.findIndex(q => q.data.dataItem.id == id);
		if (index >= 0) nodes.splice(index, 1);
		else {
			nodes.forEach(node => {
				this.recursiveDeleteNode(id, node.children);
			});
		}
	}

	private findNode(id: string, node: any = this.orgData[0]) {
		if (node.data.dataItem.id == id) return node;
		else {
			let model = null;
			for (let index = 0; index < node.children.length; index++) {
				model = this.findNode(id, node.children[index]);
				if (model) break;
			}
			return model;
		}
	}

	private findDataModel(id: string, dataModel: any = this.dataItems) {
		if (dataModel.id == id) return dataModel;
		else {
			let model = null;
			for (let index = 0; index < dataModel.children.length; index++) {
				model = this.findDataModel(id, dataModel.children[index]);
				if (model) break;
			}
			return model;
		}
	}
	private cleanData(node: TreeNode<any>) {
		const data = node.data.dataItem;
		data.children = [];
		node.children?.forEach(node => {
			data.children.push(this.cleanData(node));
		});
		return data;
	}

	private getSelectedIds(ids: string[] = [], dataModel: any = this.dataItems, excludeEditId: string = null) {
		if (dataModel?.id) {
			if (excludeEditId != dataModel.id) ids.push(dataModel.id);
			dataModel.children?.forEach(dm => {
				this.getSelectedIds(ids, dm, excludeEditId);
			});
		}
		return ids.join();
	}

	private addToParent(node: TreeNode<any>, parentId: string, item: TreeNode<any>) {
		if (node.data.dataItem.id == parentId) {
			node.children.push(item);
			node.children.forEach((item, index) => item.data.dataItem.order = index);
		}
		else {
			node.children.forEach(n => this.addToParent(n, parentId, item));
		};
	}

	private initItems(node: OrgNodeConfig) {
		if (node.image) {
			node.image = Utils.interpolate(node.image, { config: this.formioAppConfig });
		}

		if (node.maxItem)
			node.maxItem = this.formioComponent.evaluate(node.maxItem, { data: this.data });

		node.children?.forEach(item => {
			this.initItems(item);
		});
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang == 'ar' ? 'rtl' : 'ltr';
		});
	}

	private init() {
		WZoom.create('#orgContent', {
			type: 'html',
			width: 4000,
			height: 750,
			minScale: 0.5,
			maxScale: 100,
			zoomOnClick: false
		});
	}
}
